import { cn } from '@edvi-tech/ui/lib/utils'
import { withRequiredMark } from './requiredMark'

/**
 * Compatibility Radio group — same Controls.Radio props API.
 */
export default function RadioControl(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options = [],
    color: _color,
    className,
    ...other
  } = props

  return (
    <fieldset className={cn('edvi-control-field w-full border-0 p-0', className)}>
      {label ? (
        <legend className="mb-2 text-[13px] font-medium text-[#1c2434]">
          {withRequiredMark(label)}
        </legend>
      ) : null}
      <div
        className="flex flex-wrap gap-4"
        role="radiogroup"
        aria-label={label || name}
      >
        {options.map((item) => (
          <label
            key={item.id}
            className="inline-flex cursor-pointer items-center gap-2 text-sm text-[#1c2434]"
          >
            <input
              type="radio"
              name={name}
              value={item.id}
              checked={String(value) === String(item.id)}
              onChange={onChange}
              className="size-4 accent-[#5f80eb]"
              {...other}
            />
            {item.title}
          </label>
        ))}
      </div>
      {error ? <p className="mt-1 text-xs text-[#ff4c04]">{error}</p> : null}
    </fieldset>
  )
}
